// import React, { useEffect, useState } from 'react'
// import { sitePolicy } from '../asiosConfig';
// import { toast } from 'react-toastify';
// import { Box, Container, Paper, Skeleton, Typography } from '@mui/material';

// import Navbar from './Navbar';

// import Footer from './Footer';
// export const PrivacyPolicy = () => {
//     const [policy, setpolicy] = useState({});
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         const fetchAboutUs = async () => {
//             try {
//                 const response = await sitePolicy();
//                 if (response.status === 200 || response.status === 201) {
//                     setpolicy(response.data.data);

//                 } else {
//                     toast.error('Failed to fetch about us data');
//                 }
//             } catch (error) {
//                 toast.error('Failed to fetch about us data');
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchAboutUs();
//     }, []);
//     return (
//         <Box>
//             <Navbar />
//             <Box mt={12}>
//                 <Container maxWidth={false} sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
//                     <Paper elevation={6} sx={{ p: 4, mb: 6, width: '80%', mx: 'auto' }}>
//                         <Box textAlign="center" mb={12} mt={5}>
//                             {loading ? (
//                                 <>
//                                     <Skeleton variant='text' width='60%' height={40} sx={{ mx: 'auto', mb: 3 }} />

//                                     <Skeleton variant='rectangular' width='100%' height={100} sx={{ mb: 4 }} />
//                                     <Skeleton variant='rectangular' width='100%' height={100} sx={{ mb: 4 }} />
//                                 </>
//                             ) : (
//                                 <>
//                                     <Typography
//                                         variant="h4"
//                                         component="h3"
//                                         gutterBottom
//                                         sx={{ fontFamily: "Montserrat" }}
//                                     >
//                                         IND Matrimony Privacy Policy
//                                     </Typography>
//                                     <div className='text-left' dangerouslySetInnerHTML={{ __html: policy.privacy_policy }} />
//                                 </>
//                             )}

//                         </Box>
//                     </Paper>
//                 </Container>
//             </Box>
//             <Footer />
//         </Box>
//     )
// }





import PolicyLayout from "./PolicyLayout";

export const PrivacyPolicy = () => {
  return (
    <PolicyLayout
      title="Privacy"
      highlightText="Policy"
      subtitle="This Privacy Policy explains how IND Matrimony collects, uses, stores, and protects your personal information."
      lastUpdated="12 November 2025"
      dataKey="privacy_policy"
    />
  );
};
